import { ISaleSet } from "../../model/respone/sale-set/ISaleSet";
import { apiClient } from "../apiClient";

export const SALE_SET_API_RESOURCE = "sale-set";
export const saleSetApi = {
    SelectAll: () => apiClient.get(`${SALE_SET_API_RESOURCE}`),
    Insert: (payload: ISaleSet) => apiClient.post(`${SALE_SET_API_RESOURCE}`, payload),
    Update: (payload: ISaleSet) => apiClient.put(`${SALE_SET_API_RESOURCE}`, payload),
    Delete: (id: number) => apiClient.delete(`${SALE_SET_API_RESOURCE}/${id}`),
    SelectByHocSinh: (ts_hocsinh_id: number) => apiClient.get(`${SALE_SET_API_RESOURCE}/hoc-sinh/${ts_hocsinh_id}`)
};
